import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { cryptoApi } from '../utils/api';
import { useLanguage } from '../i18n/LanguageContext';

const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const { t } = useLanguage();

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await cryptoApi.getReviews();
        if (response.data?.length > 0) { setReviews(response.data); } else { loadDefaults(); }
      } catch { loadDefaults(); }
    };
    const loadDefaults = () => {
      setReviews([
        { id: '1', user_name: 'Jean M.', rating: 5, comment: t.reviews?.r1 || 'Service rapide et fiable !' },
        { id: '2', user_name: 'Marie L.', rating: 5, comment: t.reviews?.r2 || 'Excellent taux de change.' },
        { id: '3', user_name: 'Ahmed K.', rating: 5, comment: t.reviews?.r3 || 'Interface intuitive.' },
        { id: '4', user_name: 'Sophie D.', rating: 5, comment: t.reviews?.r4 || 'Très professionnelle.' },
        { id: '5', user_name: 'Pierre B.', rating: 5, comment: t.reviews?.r5 || 'Frais très compétitifs.' },
        { id: '6', user_name: 'Alexei R.', rating: 5, comment: t.reviews?.r6 || 'Excellente plateforme !' },
      ]);
    };
    fetchReviews();
  }, [t]);

  if (reviews.length === 0) return null;

  return (
    <section className="py-24 px-6 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-extrabold text-4xl md:text-5xl text-gray-900 mb-12 text-center tracking-tight" style={{ fontFamily: 'Manrope' }}>{t.reviews?.title || 'Ce que disent nos clients'}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((review) => (
            <div key={review.id} className="bg-[#F5F6F7] rounded-3xl p-8 hover:-translate-y-1 transition-transform duration-200" data-testid={`review-${review.id}`}>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-11 h-11 rounded-full bg-[#191C1F] flex items-center justify-center text-sm font-bold text-white">
                  {review.user_name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{review.user_name}</div>
                  <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className={`w-3 h-3 ${i < review.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-200'}`} />)}</div>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
